import { IVentureExperienceLevelBase } from '../../models/ventureExperienceLevels';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IUpdateVentureExperienceLevelsProps {
  experienceLevelId: string;
  maxAllowedBookingExperience: number;
  minAllowedBookingExperience: number;
  title: string;
  level: number;
}

export type IUpdatedVentureExperienceLevel = IVentureExperienceLevelBase;

export const updateVentureExperienceLevelsService = async ({
  experienceLevelId,
  maxAllowedBookingExperience,
  minAllowedBookingExperience,
  title,
  level,
}: IUpdateVentureExperienceLevelsProps): Promise<IUpdatedVentureExperienceLevel> => {
  const { data } = await jhsfBookingsApi.put<IUpdatedVentureExperienceLevel>(
    `/ventures/experience-levels/${experienceLevelId}`,
    {
      maxAllowedBookingExperience,
      minAllowedBookingExperience,
      title,
      level,
    },
  );

  return data;
};
